import React from "react";
import TeamImageLG2 from '../../assets/images/team_lg2.svg';
import InspiraLogo from '../../assets/images/inspira_logo.png';
import { motion } from 'framer-motion';

export default function TeamSection({ id }) {
    const text_bold = 'font-bold';

    return (
        <motion.div
            initial={{ y: 20, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeInOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="min-h-screen scroll-mt-36 lg:mb-20" id={id}
        >

            {/* Desktop layout */}
            <div className="hidden lg:block">
                <img
                    src='/assets/images/team_lg.svg'
                    alt="Team"
                    className="w-8/12 mx-auto"
                />
                <div className="flex justify-start gap-3">
                    <div className="w-5/12 flex justify-end">
                        <img
                            src={TeamImageLG2}
                            alt='Team2'
                            className="w-6/12 mr-16 mt-10"
                        />
                    </div>
                    <div className="flex w-5/12 flex-col mt-10">
                        <motion.img
                            src={InspiraLogo}
                            alt='Logo Inspira'
                            className='w-6/12'
                            initial={{ scale: 0 }}
                            whileInView={{ scale: 1 }}
                            viewport={{ amount: 0.9, once: true }}
                            transition={{ type: 'spring', stiffness: 70 }}
                        />
                        <p className="font-lato text-xl w-full mt-4">
                            Somos Inspira Cambio,
                            <span className={text_bold}>
                                {" "} una asociación civil con 12 años de experiencia implementando programas de VIH, salud sexual y consumo de sustancias bajo un modelo de intervención centrado en la persona impulsado por un compromiso con la justicia social.
                            </span>{" "}
                            Buscamos promover la salud sexual a través del cuidado placentero, conoce nuestro trabajo y cómo nos puedes apoyar a seguir brindando nuestros servicios.
                        </p>
                    </div>
                </div>
            </div>

            {/* Mobile & Tablet layout */}
            <div className="flex flex-col items-center text-center px-4 gap-6 lg:hidden">
                <img
                    src='/assets/images/team_m.svg'
                    alt="Team mobile 1"
                    className="w-10/12 mt-10"
                />
                <motion.img
                    src={InspiraLogo}
                    alt='Logo Inspira'
                    className='w-6/12'
                    initial={{ scale: 0 }}
                    whileInView={{ scale: 1 }}
                    viewport={{ amount: 0.9, once: true }}
                    transition={{ type: 'spring', stiffness: 70 }}
                />
                <p className="font-lato text-xs md:text-xl md:my-12 w-9/12 text-justify">
                    Somos Inspira Cambio,
                    <span className={text_bold}>
                        {" "} una asociación civil con 12 años de experiencia implementando programas de VIH, salud sexual y consumo de sustancias bajo un modelo de intervención centrado en la persona impulsado por un compromiso con la justicia social.
                    </span>{" "}
                    Buscamos promover la salud sexual a través del cuidado placentero, conoce nuestro trabajo y cómo nos puedes apoyar a seguir brindando nuestros servicios.
                </p>
                <img
                    src='/assets/images/team_m2.svg'
                    alt="Team mobile 2"
                    className="w-10/12 mb-10"
                />
            </div>
        </motion.div>
    );
}
